import { Bot } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button } from '@/components/ui/button';
import { env } from '@/shared/lib/config/env';

import Chat from '../../chat';

const showChatIntegrations = env.VITE_SHOW_CHAT_INTEGRATIONS === 'true';

const ChatWrapper = () => {
  const { sessionId: conversationId } = useParams();
  const [isChatOpen, setIsChatOpen] = useState(false);
  const handleOpenChat = () => {
    if (!showChatIntegrations && !conversationId) {
      toast.warning('Для открытия чата перейдите на страницу протокола');
      return;
    }
    setIsChatOpen(!isChatOpen);
  };

  useEffect(() => {
    if (!showChatIntegrations && !conversationId) {
      setIsChatOpen(false);
    }
  }, [conversationId]);

  return (
    <>
      {!isChatOpen && (
        <Button
          onClick={handleOpenChat}
          className="fixed bottom-5 right-5 w-[60px] h-[60px] rounded-full bg-blue-900/100 backdrop-blur-sm text-white border-none cursor-pointer flex items-center justify-center text-2xl z-[1000] hover:bg-blue-600"
        >
          <Bot style={{ width: '32px', height: '32px' }} />
        </Button>
      )}
      {isChatOpen && (!showChatIntegrations ? conversationId : true) && (
        <Chat isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
      )}
    </>
  );
};

export default ChatWrapper;
